import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const MedKit = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7790)">
      <rect x="13" y="4" width="6" height="24" fill="currentColor" />
      <rect x="28" y="13" width="6" height="24" transform="rotate(90 28 13)" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7790">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'MedKit'
);
